import React from 'react';
import { ui } from '../../config/uiSizes';
import { useFindingsDisclosure } from './FindingsDisclosureContext';

interface FindingsDisclosureToolbarProps {
    /** Optional extra classes for the outer container. */
    className?: string;
}

/**
 * "Expand all / Collapse all" control for the collapsible findings sections. Renders nothing outside a
 * `FindingsDisclosureProvider`, so it is safe to drop in unconditionally.
 */
const FindingsDisclosureToolbar: React.FC<FindingsDisclosureToolbarProps> = ({ className = '' }) => {
    const disclosure = useFindingsDisclosure();
    if (!disclosure) {
        return null;
    }

    const buttonClasses = `${ui.text.xs} font-medium text-blue-600 dark:text-blue-400 hover:underline focus:outline-none focus:underline`;

    return (
        <div className={`flex items-center justify-end ${ui.gap.sm} ${className}`}>
            <button type="button" onClick={disclosure.expandAll} className={buttonClasses}>
                Expand all
            </button>
            <span className="text-gray-300 dark:text-gray-600" aria-hidden="true">
                |
            </span>
            <button type="button" onClick={disclosure.collapseAll} className={buttonClasses}>
                Collapse all
            </button>
        </div>
    );
};

export default FindingsDisclosureToolbar;
